import React, {useEffect, useState} from "react";
import merchant from "../../network/services/merchant";
import {getCourierBusinessId} from "../../helpers/authenticator";
import quick_models from "../../network/models/quick_models";
import formatter from "../../helpers/number_formatter";
import general_helper, {dateFormatter, setDataTables} from "../../helpers/general_helper";
import Sider from "../../components/dashboard/Sider";
import DecisionModal from "../../components/dashboard/DecisionModal";


const RiderDetailsPage = () => {
    let id = window.location.pathname.replace("/rider/", "");
    const [riderDetails, setRiderDetails] = useState({});
    const [deliveries, setDeliveries] = useState([]);


    useEffect(() => {
        merchant.getCourierRiderDeliveryHistory(getCourierBusinessId(), id).then(response => {
            setRiderDetails(response.data.data.agent);
            setDeliveries(response.data.data.deliveries);
            setDataTables();
        }).catch(error => {
        })
    }, []);

    let agent = {...quick_models.agent, ...riderDetails};

    return (
        <div className="mainWrapper" style={{marginTop: 150}}>
            <div className="container">
                <div className="row justify-content-center">
                    <Sider data={{agent: agent, id: id}}/>
                    <div className="col-md-9">
                        <div className="card">
                            <div className="table-responsive">
                                <table className="table table-borderless">
                                    <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Drop Off</th>
                                        <th scope="col">Pick Up</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {deliveries.map((delivery, index) => {
                                        return (<tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>
                                                <a href={"/deliveries/" + delivery.delivery_id}>
                                                    {delivery.drop_off.address}
                                                </a>
                                            </td>
                                            <td>
                                                <a href={"/deliveries/" + delivery.delivery_id}>
                                                    {delivery.pick_up.address}
                                                </a>
                                            </td>
                                            <td>
                                                GH{formatter.accounting.formatMoney(delivery.quote.fee, "¢ ")}
                                            </td>
                                            <td>
                                                {dateFormatter(delivery.created_at)}
                                            </td>
                                            <td>
                                                    <span
                                                        className="badge badge-pill badge-primary">{general_helper.displayCurrentDeliveryStatus(delivery.status)}</span>
                                            </td>
                                        </tr>)
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <DecisionModal/>
                </div>
            </div>
        </div>
    )
};

export default RiderDetailsPage;
